export enum ContactsStages {
	ALL_CONTACTS = 'all_contacts',
	INFO_CONTACT = 'info_contact',
	ADD_CONTACT = 'add_contact',
}
